import { Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { type ChangeEventHandler } from "react";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { useGroupContext } from "src/components/shared/Grouping/GroupContext";
import { type IGroupOrLabel } from "src/interfaces";
import { useSelector } from "src/redux/hooks";
import { Flex } from "src/styled";

import ColorPicker from "./ColorPicker";
import {
  DeleteBox,
  GroupItemContainer,
  GroupNameInput,
} from "./GroupItem.styled";
interface Props {
  group: IGroupOrLabel;
}

const GroupItem = ({ group }: Props) => {
  const uppercase = useSelector(state => state.preferencesSlice.uppercase);
  const {
    selectedElement,
    handleEditElement,
    handleSelectElement,
    handleDeleteElement,
  } = useGroupContext();

  const changeName: ChangeEventHandler<HTMLInputElement> = e => {
    handleEditElement({
      groupId: group.groupId ?? "",
      key: "group",
      value: e.target.value,
    });
  };
  const changeColor = (color: string) => {
    handleEditElement({
      groupId: group.groupId ?? "",
      key: "color",
      value: color,
    });
  };

  const handleClick = () => {
    const isActive = selectedElement?.groupId === group.groupId;
    handleSelectElement(isActive ? null : group);
  };

  const handleRemove = () => {
    handleDeleteElement(group.groupId ?? "");
  };

  const active = selectedElement?.groupId === group.groupId;

  return (
    <GroupItemContainer onClick={handleClick} active={active}>
      <Flex direction="column" gap={24} flex={1}>
        <Flex align="center" gap={8} w={200}>
          <Text size="sm">Name:</Text>
          <GroupNameInput
            variant="unstyled"
            value={group.group}
            onChange={changeName}
            styles={{
              input: { textTransform: uppercase ? "uppercase" : "none" },
            }}
          />
        </Flex>
        <Flex align="center" gap={8}>
          <Text size="sm">Color:</Text>
          <ColorPicker color={group.color} setColor={changeColor} />
        </Flex>
      </Flex>
      <ConfirmationButton
        actionIcon
        actionIconProps={{ color: "red.5", component: DeleteBox }}
        modalText="Are you sure you want to remove this group?"
        onConfirm={handleRemove}>
        <IconTrash />
      </ConfirmationButton>
    </GroupItemContainer>
  );
};

export default GroupItem;
